import React, { useState } from "react";

import { appStage } from "@/environment";
import styled from "styled-components";
import theme from "@/styles/theme";

const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  padding: ${theme.spacing.unit * 1}px;
  background-color: ${theme.colors.red};
  color: ${theme.colors.white};
  z-index: 99999;
  font-size: 24px;
  text-transform: uppercase;
`;

function EnvironmentIndicator() {
  const [isVisible, setIsVisible] = useState(true);

  const onContainerClick = () => {
    setIsVisible(false);
  };

  return (
    <>
      {appStage === "uat" && isVisible && (
        <Container onClick={onContainerClick}>{appStage}</Container>
      )}
    </>
  );
}

export default EnvironmentIndicator;
